/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timeline_Toggle_Markers_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Toggle Markers" |
*
* @param {Timeline_Toggle_Markers_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timeline_toggle_markers_aria_label = /** @type {((inputs?: Timeline_Toggle_Markers_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timeline_Toggle_Markers_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Basculer les marqueurs")
	if (locale === "de") return /** @type {LocalizedString} */ ("Markierungen umschalten")
	if (locale === "it") return /** @type {LocalizedString} */ ("Attiva/disattiva marcatori")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Переключить маркеры")
	if (locale === "es") return /** @type {LocalizedString} */ ("Marcadores de alternancia")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("切换标记")
	if (locale === "ja") return /** @type {LocalizedString} */ ("マーカーを切り替える")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मार्कर टॉगल करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Marcadores de alternância")
	return /** @type {LocalizedString} */ ("Toggle Markers")
});